function debounce(func, wait, immediate) {
  let timeout;
  function debounced() {
    const context = this,
      args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  }
  function cancel() {
    if (timeout !== undefined) {
      clearTimeout(timeout);
    }
  }
  debounced.cancel = cancel;
  return debounced;
}

export default debounce;
